<div class="feature">
  <div class="marquee">
    <div class="track">
      <div class="content">
        <img loading="lazy" src="/assets/images/featured/feature_1.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_2.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_3.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_4.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_5.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_6.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_7.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_8.svg" alt="featured-img" />

        <img loading="lazy" src="/assets/images/featured/feature_1.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_2.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_3.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_4.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_5.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_6.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_7.svg" alt="featured-img" />
        <img loading="lazy" src="/assets/images/featured/feature_8.svg" alt="featured-img" />
      </div>
    </div>

  </div>
</div>
